import React from "react";

const CommonProgress = () => {
  return (
    <>
      <div>
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </div>
    </>
  );
};

export default CommonProgress;
